export default {"src":"/_next/static/media/staysure-bcuk-primary.244a5836.svg","height":33,"width":140,"blurWidth":0,"blurHeight":0};